import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutExtraPay extends Layout {
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelOverridePay: Label;
    labelSettlement: Label;
    labelTotalExtraPayAmount: Label;
    labelTotalPayAdjustments: Label;
    panelMoveInfo: Panel;
    panelOverridePay: Panel;
    panelPayAdjustments: Panel;
    panelSettlement: Panel;
    sourceExtraPay: DataSource;
    sourceMovement: DataSource;
    switchAuthorized: Switch;
    tableExtraPay: Table;
    textboxOverridePayAmt: Textbox;
    textboxOverridePayRate: Textbox;
    textboxOverridePayeeId: Textbox;
    textboxOverrideType: Textbox;
    textboxOverrideUnits: Textbox;
    textboxSettlementDate: Textbox;
}
